import { createFeatureSelector } from '@ngrx/store';
import { DesignState } from './design.reducer';

export const DESIGN_STORE_KEY = 'design';

export const selectDesign =
  createFeatureSelector<DesignState>(DESIGN_STORE_KEY);
